import { Button, Popconfirm } from 'antd';

interface Props {
  handleDocumentRemove: () => void;
  disabled?: boolean;
}

function CancelLS({ handleDocumentRemove, disabled = false }: Props) {
  const button = (
    <Button
      type="primary"
      danger
      htmlType="button"
      disabled={disabled}
    >
      Аннулировать СЗ
    </Button>
  );

  if (disabled) {
    return button;
  }

  return (
    <Popconfirm
      title="Подтвердить аннулирование"
      onConfirm={handleDocumentRemove}
      okText="Да"
      cancelText="Нет"
    >
      {button}
    </Popconfirm>
  );
}

export default CancelLS;
